/**
 * Ausdehnung einer Punktfolge und das Einpassen in die Karte.
 *
 * Bewusst ohne `Math.min(...liste)`: mit Hunderttausenden Argumenten wirft das
 * einen RangeError, und genau so lang wird eine eingelesene GPX-Spur.
 */
export function grenzen(punkte) {
  let w = Infinity, s = Infinity, o = -Infinity, n = -Infinity;
  for (const [lng, lat] of punkte) {
    if (lng < w) w = lng;
    if (lng > o) o = lng;
    if (lat < s) s = lat;
    if (lat > n) n = lat;
  }
  return Number.isFinite(w) ? [[w, s], [o, n]] : null;
}

/**
 * Rand um das Eingepasste. Auf dem Telefon wären feste 70 Punkte links und
 * rechts bereits ein Drittel der Karte.
 */
function rand(map) {
  const c = map.getContainer();
  return Math.round(Math.min(70, Math.max(28, Math.min(c.clientWidth, c.clientHeight) * 0.1)));
}

export function einpassen(map, punkte, optionen = {}) {
  const g = grenzen(punkte);
  if (!g) return;
  map.fitBounds(g, { padding: rand(map), duration: 700, ...optionen });
}
